module.exports = __webpack_public_path__ + "img/play.a31bf6da.svg";